import {
  FETCH_CATEGORIES_LIST,
  SELECT_CATEGORY,
  FETCH_TAGS_LIST_FOR_CATEGORY,
  FETCH_TAGS_LIST_FOR_CATEGORY_SUCCESS,
  FETCH_TAGS_LIST_FOR_FAILURE,
  FETCH_SUB_TAGS_LIST_FOR_CATEGORY,
  FETCH_SUB_TAGS_LIST_FOR_CATEGORY_SUCCESS,
  SAVING_CATEGORY,
  SAVING_CATEGORY_SUCCESS,
  SAVING_CATEGORY_FAILURE,
  SAVING_TAG,
  SAVING_TAG_FAILURE,
  SAVING_TAG_SUCCESS,
  UPLOAD_TAGS,
  UPLOAD_TAGS_SUCCESS,
  UPLOAD_TAGS_FAILURE,
  IMPORT_TAGS,
  IMPORT_TAGS_SUCCESS,
  IMPORT_TAGS_FAILURE,
  DELETE_TAG,
  DELETE_TAG_SUCCESS,
  DELETE_TAG_FAILURE,
  CLEAR_IMPORTED_TAGS_ENTITIES,
} from './types';
import initialState from './initialState';

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_CATEGORIES_LIST:
      return {
        ...state,
        categoriesList: action.categoriesList,
        categoryViews: action.categoryViews,
      };
    case SELECT_CATEGORY:
      return {
        ...state,
        category: action.category,
      };
    case FETCH_TAGS_LIST_FOR_CATEGORY:
      return {
        ...state,
        fetchTagsError: initialState.fetchTagsError,
        tagsLoading: true,
      };
    case FETCH_TAGS_LIST_FOR_CATEGORY_SUCCESS:
      return {
        ...state,
        tagsList: action.tagsList,
        tagsLoading: false,
      };
    case FETCH_SUB_TAGS_LIST_FOR_CATEGORY:
      return {
        ...state,
        fetchSubTagsError: initialState.fetchSubTagsError,
        subTagsLoading: true,
      };
    case FETCH_SUB_TAGS_LIST_FOR_CATEGORY_SUCCESS:
      return {
        ...state,
        subTagsList: action.subTagsList,
        subTagsLoading: false,
      };
    case FETCH_TAGS_LIST_FOR_FAILURE:
      return {
        ...state,
        tagsList: initialState.tagsList,
        tagsLoading: false,
      };
    case SAVING_CATEGORY:
      return {
        ...state,
        isSavingCategoriesInProgress: true,
      };
    case SAVING_CATEGORY_SUCCESS:
    case SAVING_CATEGORY_FAILURE:
      return {
        ...state,
        isSavingCategoriesInProgress: false,
      };
    case SAVING_TAG:
      return {
        ...state,
        isSavingTagInProgress: true,
      };
    case SAVING_TAG_FAILURE:
    case SAVING_TAG_SUCCESS:
      return {
        ...state,
        isSavingTagInProgress: false,
      };
    case UPLOAD_TAGS:
      return {
        ...state,
        isUploadingTags: true,
      };
    case UPLOAD_TAGS_SUCCESS: {
      return {
        ...state,
        isUploadingTags: false,
        uploadedTags: action.uploadedTags,
      };
    }
    case UPLOAD_TAGS_FAILURE: {
      return {
        ...state,
        isUploadingTags: false,
      };
    }
    case IMPORT_TAGS: {
      return {
        ...state,
        isImportingTags: true,
      };
    }
    case IMPORT_TAGS_SUCCESS:
      return {
        ...state,
        isImportingTags: false,
        uploadedTags: [],
      };
    case IMPORT_TAGS_FAILURE:
      return {
        ...state,
        isImportingTags: false,
      };
    case CLEAR_IMPORTED_TAGS_ENTITIES:
      return {
        ...state,
        uploadedTags: [],
      };
    case DELETE_TAG:
      return {
        ...state,
        isDeletingTagInProgress: true,
      };
    case DELETE_TAG_SUCCESS:
    case DELETE_TAG_FAILURE:
      return {
        ...state,
        isDeletingTagInProgress: false,
      };
    default:
      return state;
  }
}
